module.exports = __webpack_public_path__ + "static/media/slogo.a251eea7.png";